// extracted by mini-css-extract-plugin
export default {"wrapper":"WrapperScrollbar_wrapper__vLJJV","wrapper_type_thin":"WrapperScrollbar_wrapper_type_thin__8lURO"};